import React, { createContext, useContext, useState } from 'react';
import moment from 'moment';

const DateTimeContext = createContext();

export const DateTimeProvider = ({ children }) => {
  const [dueDate, setDueDate] = useState();
  const [hour, setHour] = useState();
  const [minute, setMinute] = useState();
  const [period, setPeriod] = useState();
  const [showDate, setShowDate] = useState();
  const [showTime, setShowTime] = useState();

  const resetDate = () => {
    setDueDate(new Date());
  };

  const getHour24h = (passedTime) =>
    passedTime.hours() % 12 > 0 ? passedTime.hours() % 12 : 12;

  const resetTime = () => {
    const start = moment();
    const remainder = 30 - (start.minute() % 30);
    const roundedTime = moment(start).add(remainder, 'minutes');

    setHour(getHour24h(roundedTime));
    setMinute(roundedTime.minutes());
    setPeriod(roundedTime.format('A'));
  };

  const toggleDate = () => {
    const toggle = !showDate;
    setShowDate(toggle);

    if (!toggle) {
      resetDate();
      toggleTime('manual');
    }
  };

  const toggleTime = (type = 'auto') => {
    if (type == 'auto') {
      const toggle = !showTime;
      setShowTime(toggle);

      if (toggle) setShowDate(true);
      else resetTime();
    } else {
      setShowTime(false);
      resetTime();
    }
  };

  const changeHour = (newHour) => {
  
      if (newHour > 12) setHour(12);
      else if (newHour < 1) setHour(1);
      else setHour(newHour);
    
  };

  const changeMinute = (newMinute) => {
    if (newMinute > 59) setMinute(59);
    else if (newMinute < 0) setMinute(0);
    else setMinute(newMinute);
  };

  return (
    <DateTimeContext.Provider
      value={{
        dueDate,
        setDueDate,
        hour,
        setHour,
        minute,
        setMinute,
        period,
        setPeriod,
        showDate,
        setShowDate,
        showTime,
        setShowTime,
        resetDate,
        resetTime,
        toggleDate,
        toggleTime,
        changeHour,
        changeMinute,
        getHour24h,
      }}
    >
      {children}
    </DateTimeContext.Provider>
  );
};

export const useDateTimeContext = () => useContext(DateTimeContext);
